export const CONDITION_TYPE_ANNUAL_FEES = 'ANNUAL_FEES';
export const CONDITION_TYPE_COUPLE = 'COUPLE';
export const CONDITION_TYPE_FAMILY_SB = 'FAMILY_SB';
export const CONDITION_TYPE_MULTIPLE_COURSES = 'MULTIPLE_COURSES';
export const CONDITION_TYPE_SUBSIDY = 'SUBSIDY';
export const CONDITION_TYPE_OTHER = 'OTHER';

export const PAYMENT_FREQUENCY_ANNUAL = 'ANNUAL';
export const PAYMENT_FREQUENCY_PERIOD = 'PERIOD';
